var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "info-circle-Filled_1_",
    d: "M361.5,2555a12.5,12.5,0,1,0,12.5,12.5A12.521,12.521,0,0,0,361.5,2555Zm1.25,17.5a1.25,1.25,0,0,1-2.5,0v-5a1.25,1.25,0,1,1,2.5,0Zm-1.25-8.75a1.25,1.25,0,1,1,1.25-1.251A1.254,1.254,0,0,1,361.5,2563.751Z",
    transform: "translate(-349 -2555)",
    fill: "#fff",
    opacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.0b1abcc9c74c0a633871015360614981.svg";
export { ForwardRef as ReactComponent };